module.exports = __webpack_public_path__ + "static/media/circle.a8ae1a79.svg";